import { SearchResultsPage } from './search-results/search-results.page';

export const PAGES = [
  SearchResultsPage
];
